import styled, { TColorsName } from 'styled-components'

import { Button as CButton } from 'core/components'
import { convertHexToRGBA } from 'core/helpers'

import { TRewardStyles } from './types'

const Wrapper = styled.div`
  position: relative;
  height: 100%;
`

const Reward = {
  Container: styled.div`
    height: 80%;
    display: grid;
    grid-template-rows: 20% 55% 25%;
    padding: 5% 0;
    text-align: center;

    &:last-of-type {
      padding-bottom: 15%;
    }
  `,

  Score: {
    Container: styled.div`
      display: flex;
      justify-content: center;
      align-items: center;
    `,

    Overlap: styled.div`
      position: absolute;
      display: grid;
      grid-template-rows: 50% 50%;
      justify-items: center;
      grid-row-gap: 3px;
      margin-top: -5px;
      margin-left: -1px;
      color: ${p => p.theme.colors.light};
      width: 100%;

      @supports (-webkit-touch-callout: none) {
        margin-top: -4px;
        margin-left: 0;
      }
    `,

    Span: styled.span`
      font-size: 1.2rem;
      font-weight: bolder;
    `,

    Label: styled.label`
      font-size: 0.5rem;
    `,
  },

  Image: {
    Cover: styled.div`
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    `,

    Preview: styled.img`
      margin: 0 auto 0 auto;
      max-width: 60%;
      max-height: 80%;

      @media screen and (min-width: 40em) {
        padding: 0 2em 0 2em;
        width: 30%;
      }
    `,
  },

  Details: {
    Container: styled.div`
      font-family: ${p => p.theme.fonts.tertiary};
      color: ${p => convertHexToRGBA({ hex: p.theme.colors.dark, opacity: 7 })};
    `,

    Title: styled.h3`
      font-size: 1.6rem;
      font-weight: bolder;
      margin-bottom: 10px;
    `,

    Info: styled.label<TRewardStyles>`
      font-size: 0.85rem;
      color: ${p => p.theme.colors[p.color as TColorsName] || p.color};
      opacity: 0.8;
      margin: 15px 0;
    `,
  },
}

const Button = styled(CButton)`
  height: 30px;
  max-width: 170px;
  border-radius: 50px;
  font-size: 0.8rem;
  background: ${p => p.theme.colors[p.color as TColorsName] || p.color};
  margin: 10px auto;
`

const List = {
  Container: styled.ul`
    position: relative;
    min-height: 60px;
    margin-top: 10px;
    width: 100%;
    max-height: 220px;
    overflow: auto;
  `,

  Item: styled.li`
    position: relative;
    height: 40px;
    display: flex;
    justify-content: start;
    align-items: center;
    margin-left: 30px;

    ::before {
      position: absolute;
      content: ' ';
      left: -20px;
      height: 6px;
      width: 6px;
      border-radius: 50px;
      background: ${p => p.theme.colors.secondary};
    }
  `,

  Empty: styled.span`
    text-align: center;
  `,
}

const Empty = styled.div`
  font-family: ${p => p.theme.fonts.secondary};
  text-align: center;
  color: ${p => p.theme.colors.dark};
  padding-top: 10px;
`

export { Wrapper, Empty, Button, List, Reward }
